"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineContentFilters;
function AlpineContentFilters() {
    return Alpine.data('contentFilters', function () { return ({
        API_URL: '',
        loading: true,
        filterOpen: '',
        search: {
            terms: {
                industry: [],
                product_category: [],
                application: [],
            },
            postTypes: ['POST', 'PAGE'],
            order: 'DESC',
            orderby: 'DATE',
        },
        results: [],
        nextCursor: '',
        hasNextPage: true,
        init: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.API_URL = '/graphql';
                            return [4 /*yield*/, this.getDefaultValuesFromDOM()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.getResults(false)];
                        case 2:
                            _a.sent();
                            this.loading = false;
                            return [2 /*return*/];
                    }
                });
            });
        },
        getDefaultValuesFromDOM: function () {
            var _this = this;
            return new Promise(function (resolve) {
                if (_this.$root.dataset.defaultIndustry.length > 0) {
                    _this.search.terms.industry = _this.$root.dataset.defaultIndustry.split(',');
                }
                if (_this.$root.dataset.defaultProductCategory.length > 0) {
                    _this.search.terms.product_category = _this.$root.dataset.defaultProductCategory.split(',');
                }
                if (_this.$root.dataset.defaultApplication.length > 0) {
                    _this.search.terms.application = _this.$root.dataset.defaultApplication.split(',');
                }
                if (_this.$root.dataset.postTypes.length > 0) {
                    _this.search.postTypes = _this.$root.dataset.postTypes.split(',');
                }
                if (_this.$root.dataset.order.length > 0) {
                    _this.search.order = _this.$root.dataset.order;
                }
                if (_this.$root.dataset.orderby.length > 0) {
                    if (_this.$root.dataset.orderby === 'none') {
                        _this.search.orderby = 'MENU_ORDER';
                    }
                    else {
                        _this.search.orderby = _this.$root.dataset.orderby;
                    }
                }
                resolve();
            });
        },
        getResults: function (isLoadMore) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.loading = true;
                            if (!isLoadMore) {
                                this.results = [];
                            }
                            return [4 /*yield*/, fetch(this.API_URL, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        query: "query GetContentForContentFiltersBlock {\n            contentNodes(\n              first: 8\n              ".concat((isLoadMore) ? "\n                after: \"".concat(this.nextCursor, "\"\n              ") : '', "\n              where: {\n                contentTypes: [").concat(this.queryPostTypesParams, "],\n                orderby: {field: ").concat(this.search.orderby.toUpperCase(), ", order: ").concat(this.search.order.toUpperCase(), "},\n                taxQuery: {\n                  relation: AND,\n                  taxArray: [").concat(this.queryTaxonomyParams, "]\n                },\n                ").concat(this.metaQueryParams, "\n              }\n            ) {\n              nodes {\n                ... on Page_case_study {\n                  ").concat(this.queryReturnFields, "\n                }\n                ... on Page_weighing_guide {\n                  ").concat(this.queryReturnFields, "\n                }\n                ... on Post {\n                  ").concat(this.queryReturnFields, "\n                }\n                ... on Page {\n                  ").concat(this.queryReturnFields, "\n                }\n                ... on Product {\n                  ").concat(this.queryReturnFields, "\n                }\n              }\n              pageInfo {\n                hasNextPage\n                endCursor\n              }\n            }\n          }"),
                                    }),
                                })
                                    .then(function (res) { return res.json(); })
                                    .then(function (data) {
                                    if (data.data) {
                                        _this.results = _this.results.concat(data.data.contentNodes.nodes);
                                        _this.nextCursor = data.data.contentNodes.pageInfo.endCursor;
                                        _this.hasNextPage = data.data.contentNodes.pageInfo.hasNextPage;
                                        _this.loading = false;
                                    }
                                    else {
                                        _this.loading = false;
                                        _this.results = [];
                                    }
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        get queryReturnFields() {
            return "\n        title\n        link\n        teaser {\n          excerpt\n        }\n        featuredImage {\n          node {\n            srcSet\n            mediaItemUrl\n          }\n        }\n        contentTypeName\n      ";
        },
        get queryTaxonomyParams() {
            var _this = this;
            var string = '';
            Object.keys(this.search.terms).forEach(function (key) {
                var values = _this.search.terms[key];
                if (values.length) {
                    string = "".concat(string, " {\n            taxonomy: TAX_").concat(key.toUpperCase(), ",\n            operator: IN,\n            field: ID,\n            terms: [").concat(values.map(function (id) { return "\"".concat(id, "\""); }).join(','), "]\n          }, ");
                }
            });
            return string;
        },
        get queryPostTypesParams() {
            var string = '';
            this.search.postTypes.forEach(function (type) {
                string = "".concat(string).concat(type, ",");
            });
            return string;
        },
        get metaQueryParams() {
            var string = '';
            /* If search.postTypes includes "Product" then add meta query to exclude
             * products with _sku meta key
             */
            if (this.search.postTypes.includes('PRODUCT')) {
                string = 'metaQuery: {metaArray: {compare: NOT_EXISTS, key: "_sku"}}';
            }
            return string;
        },
    }); });
}
